import React,{useEffect, useState} from "react";
import SmallFooter from "../componants/footer/smallFooter";
import ScrollTop from "../componants/scrollTop";
import PersonalNavbarPages from "./navbar/personalNavbarPages";

export default function PrivacyPolicy(){
    return(
        <>
        <PersonalNavbarPages items={[{titulo:'Política de privacidad', 'id':'politicaPrivacidad'}]} />

        <section className="section mt-5" id="politicaPrivacidad" style={{ paddingTop:'1rem' }}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4">
                            <h4 className="title mb-4"><br/>POLíTICA DE PRIVACIDAD</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-12">
                        <p style={{textAlign:'justify'}}>
                            Tu privacidad es importante para <span className="h6">pilatesrizzo.com</span>
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Por eso en cumplimiento de lo que se dispone en el artículo 5 de la Ley Orgánica
                            15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal (LOPD), le
                            informamos que los datos de carácter personal que nos proporcione rellenando el
                            formulario de registro electrónico o por cualquier otro medio, se recogerán en ficheros
                            cuyo responsable es Pilates Rizzo S.L.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            En virtud de lo dispuesto en el artículo 15 y siguientes de la LOPD y en los términos
                            que indica su Reglamento de desarrollo aprobado por Real Decreto 1720/2007, de 21
                            de diciembre (RLOPD), en cualquier momento usted podrá ejercer sus derechos de
                            acceso, rectificación, cancelación y oposición, dirigiéndose a Pilates Rizzo S.L.,
                            dirigiéndose a info@pilatesrizzo.com. Le rogamos que comunique inmediatamente
                            cualquier modificación de sus datos de carácter personal para que la información que
                            contienen nuestros ficheros esté siempre actualizada y no contenga errores.
                            Asimismo, con la aceptación de esta Política de privacidad, reconoce que la
                            información y los datos personales recogidos son exactos y veraces.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            La recogida de sus datos de carácter personal se hace con la finalidad de transmitirte
                            información de carácter comercial, publicidad de productos y servicios de interés de la
                            Empresa.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Pilates Rizzo S.L. no vende, alquila ni cede datos de carácter personal que puedan
                            identificar al usuario, ni lo hará en el futuro, a terceros sin el consentimiento previo.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Las cookies utilizadas no pueden leer los archivos cookie creados por otros
                            proveedores. El usuario tiene la posibilidad de configurar su navegador para ser
                            avisado en pantalla de la recepción de cookies y para impedir la instalación de cookies
                            en su disco duro.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Actualmente, la mayoría de los navegadores vienen configurados por defecto para
                            bloquear la instalación de cookies de publicidad o de terceros en su equipo. El usuario
                            puede ampliar las restricciones de origen, impidiendo la entrada de cualquier tipo de
                            cookie o, por el contrario, eliminar dichas restricciones, aceptando la entrada de
                            cualquier tipo de cookies.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Si el usuario ha modificado voluntariamente la configuración del navegador para
                            admitir cookies de publicidad o de terceros, dicha acción significará que da su
                            consentimiento para el tratamiento de sus datos a los efectos de publicidad.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            De acuerdo con lo establecido en el Real Decreto-ley 13/2012, de 30 de marzo, no
                            será necesario el consentimiento del usuario cuando el almacenamiento o acceso
                            relativos a las cookies sean de índole técnica al solo fin de efectuar la transmisión de
                            una comunicación por una red de comunicaciones electrónicas o, en la medida que
                            resulte estrictamente necesario, para la prestación de un servicio de la sociedad de la
                            información expresamente solicitado por el destinatario.
                        </p>
                        <h5>Finalidad del tratamiento de datos</h5>
                        <p>
                            Utilizamos los datos personales para:
                        </p>
                        <ul>
                            <li style={{display:'none'}}></li>
                            <li style={{textAlign:'justify'}}>Gestionar solicitudes de información sobre nuestros servicios de pilates.</li>
                            <li style={{textAlign:'justify'}}>Enviar comunicaciones relacionadas con clases, horarios y eventos del centro.</li>
                            <li style={{textAlign:'justify'}}>Realizar análisis estadísticos para mejorar la experiencia del usuario.</li>
                        </ul>
                        <p style={{textAlign:'justify'}}>No utilizamos los datos para decisiones automatizadas ni elaboración de perfiles.</p>
                        <h5>Legitimación para el tratamiento de datos</h5>
                        <p>
                            El tratamiento de tus datos está basado en:
                        </p>
                        <ul>
                            <li style={{display:'none'}}></li>
                            <li style={{textAlign:'justify'}}>Tu consentimiento al completar formularios de contacto.</li>
                            <li style={{textAlign:'justify'}}>Interés legítimo para la mejora de nuestros servicios.</li>
                        </ul>
                        <h5>Conservación de los datos</h5>
                        <p>
                            Tus datos personales se conservarán:
                        </p>
                        <ul>
                            <li style={{display:'none'}}></li>
                            <li style={{textAlign:'justify'}}>Mientras mantengamos una relación comercial o hasta que solicites su supresión.</li>
                            <li style={{textAlign:'justify'}}>Durante el tiempo necesario para cumplir con obligaciones legales.</li>
                        </ul>
                        <h5>Seguridad de los datos</h5>
                        <p style={{textAlign:'justify'}}>
                            Adoptamos las medidas técnicas y organizativas necesarias para garantizar la
                            seguridad de tus datos y protegerlos contra el acceso no autorizado, la pérdida o la
                            alteración.
                        </p>
                        <h5>Cambios en la política de privacidad</h5>
                        <p style={{textAlign:'justify'}}>
                            Podemos actualizar esta política de privacidad en cualquier momento. Te notificaremos
                            cualquier cambio significativo publicando una versión actualizada en nuestra web.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Te recomendamos revisar periódicamente esta política para estar informado sobre
                            cómo protegemos tu información.
                        </p>
                        <h5>Responsable del tratamiento de los datos</h5>
                        <ul>
                            <li style={{display:'none'}}></li>
                            <li><span className="h6">Identidad:</span> Pilates Rizzo S.L.</li>
                            <li><span className="h6">NIF/CIF:</span> B72643638</li>
                            <li><span className="h6">Dirección:</span> Calle Téllez 17º, 4 C, Madrid 28007</li>
                            <li><span className="h6">Correo electrónico:</span> info@pilatesrizzo.com</li>
                            <li><span className="h6">Teléfono:</span> 623255264</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <SmallFooter/>
        <ScrollTop/>

        </>
    )
}

// rosa: #dacbd2
// lila: #735fb3
// verde: #bdcec8
